import React from "react";
import { ProfileImages } from "../../../../common/styled/project";

const Preview = ({ createGroup, checked, handleAdd, renderProfileImages }) => {
  return (
    <div className="preview">
      <div className="selected">
        <ProfileImages>{renderProfileImages([createGroup, ...checked])}</ProfileImages>
        <div>
          <span>
            {createGroup?.orgNm}
            {checked?.length > 0 ? ", " : ""}
          </span>
          {checked.map((item, idx) => (
            <span key={item.orgNo}>
              {item.orgNm}
              {idx < checked.length - 1 && ", "}
            </span>
          ))}
        </div>
      </div>
      <button onClick={handleAdd} className={checked?.length > 0 ? "active" : "inactive"}>
        추가
      </button>
    </div>
  );
};

export default Preview;
